const API_BASE = process.env.NODE_ENV === 'production' 
    ? '' // ← producción: usa rutas relativas como /api/login
    : 'http://localhost:8000' // desarrollo

const API_ROUTES = {
    //AUTENTICATION
    CHECK_AUTH: `${API_BASE}/api/checkauth`,
    LOGIN: `${API_BASE}/api/login`,
    LOGOUT: `${API_BASE}/api/logout`,
    REGISTER: `${API_BASE}/api/register`,
    FORGOT_PASSWORD: `${API_BASE}/api/forgot-password`,
    RESET_PASSWORD: `${API_BASE}/api/reset-password`,
    //USER
    USERS: `${API_BASE}/api/users`,
    USER_SUSPEND: `${API_BASE}/api/users/suspend`,
    USER_DELETE: `${API_BASE}/api/users/delete`,
    ADMINS_ADDADMIN: `${API_BASE}/api/admins/addadmin`,
    ADMINS_REMOVE: `${API_BASE}/api/admins/remove`,
    //COMPANY
    COMPANIES: `${API_BASE}/api/companies`,
    COMPANIES_DELETE: `${API_BASE}/api/companies/delete`,
    //CALCULATOR
    RESOURCES_TYPE: `${API_BASE}/api/resource-types`,
    EXTENSION_UNITS: `${API_BASE}/api/extension-units`,
    MULTIMEDIA_LEVELS: `${API_BASE}/api/multimedia-levels`,
    INSTRUCTIONAL_LEVELS: `${API_BASE}/api/instructional-levels`,
    CALCULATE: `${API_BASE}/api/calculate`,
    // PRICING
    HOURS_MATRIX: `${API_BASE}/api/hours-matrix`,
    PRICING_HOURS: `${API_BASE}/api/pricing`,
    // SERVER
    SYSTEMINFO: `${API_BASE}/api/systeminfo`,
    LOGS: `${API_BASE}/api/log`,
};

export default API_ROUTES;